// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__4tKZf","dragIcon":"Choice_dragIcon__2kzTD","left":"Choice_left__13FQm","input":"Choice_input__2Ksk4"};